import { useCallback, useState } from 'react'

export const useAnchoredPopover = () => {
	const [anchorElementForPopover, setAnchorElementForPopover] = useState<HTMLButtonElement | null>(null)
	const openPopover = useCallback(
		(event: React.MouseEvent<HTMLButtonElement>) => setAnchorElementForPopover(event.currentTarget),
		[],
	)

	const closePopover = useCallback(() => setAnchorElementForPopover(null), [])
	return { isPopoverOpen: !!anchorElementForPopover, anchorElementForPopover, openPopover, closePopover }
}
